import { PreVettingStep1Screen } from "@/features/vendor/pre-vetting";

export default PreVettingStep1Screen;
